import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Link as ScrollLink } from 'react-scroll'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'

// Hero assets
import Sky from '../Assets/Sky.png'
import Mountain from '../Assets/JustMountain.png'
import Logo from '../Assets/BestLogo.png'
import Cherry from '../Assets/Cherry.png'

// Staff images
import Ruben from '../Assets/ElRuben.png'
import Susan from '../Assets/SusanSimann.png'
import Cesar from '../Assets/Cesarr.png'
import Erik from '../Assets/Eriikk.jpeg'

// Brush strokes
import BrushOne from '../Assets/BrushOne.png'
import BrushTwo from '../Assets/BrushTwo.png'
import BrushThree from '../Assets/BrushThree.png'
import BrushFour from '../Assets/BrushFour.png'

// Map and cities
import Mapaa from '../Assets/Mapaa.png'
import TokyoCity from '../Assets/TokyoCity.jpg'
import Osakacity from '../Assets/oSa.jpg'
import KyotoCity from '../Assets/Kyoto.jpg'

import Japanmusic from '../Assets/MusicJap.jpg'

// Small logo for navbar
import SmallLogo from '../Assets/JapanLogo.png'

// Highlight images
import Activities from '../Assets/Activities.jpg'
import Cuisinee from '../Assets/Cuisine.jpeg'
import Animes from '../Assets/AnimeSec.jpg'
import Culture from '../Assets/Culture.jpg'

const cityData = {
  Tokyo: {
    title: 'Tokyo',
    text:
      'Tokyo is a dazzling fusion of tradition and innovation. From the iconic Shibuya Crossing to the serene Meiji Shrine, this city offers an unforgettable cultural journey. Musicians will perform in one of Japan’s grand concert halls and explore neighborhoods pulsing with creativity.',
    img: TokyoCity,
  },
  Kyoto: {
    title: 'Kyoto',
    text:
      'Kyoto is Japan’s ancient heart, known for its over 1,000 temples, imperial palaces, and tea houses. Here, you’ll perform surrounded by tradition, participate in a tea ceremony, and wander streets where geishas still gracefully roam.',
    img: KyotoCity,
  },
  Osaka: {
    title: 'Osaka',
    text:
      'Osaka is vibrant and fun-loving, famous for its street food, neon-lit nightlife, and historical castles. The tour stops here for music, laughter, and cultural immersion in Japan’s kitchen capital. Expect a warm welcome and lively crowds.',
    img: Osakacity,
  },
}

const highlights = [
  { title: 'Culture', description: 'Immerse yourself in the old tradition of Japan', img: Culture },
  { title: 'Animes', description: 'Jump into the Anime world of iconic studios like Ghibli and many others', img: Animes },
  { title: 'Cuisine', description: 'Eat with the authentic culture of the Japanese cuisine', img: Cuisinee },
  { title: 'Activities', description: 'With many activities that can only be found in Japan', img: Activities },
]

const staff = [
  { name: 'Ruben Siman', role: 'Executive Director', img: Ruben },
  { name: 'Susan Siman', role: 'Founder', img: Susan },
  { name: 'Cesar Bollero', role: 'Logistic Director', img: Cesar },
  { name: 'Erik Balbuena', role: 'String Teacher', img: Erik },
]

// Full-opacity Brush Backgrounds
function BrushBackgrounds() {
  const brushes = [
    { src: BrushOne, style: { top: '5%', left: '2%', width: '160px', rotate: '-12deg' } },
    { src: BrushTwo, style: { top: '35%', right: '4%', width: '180px', rotate: '10deg' } },
    { src: BrushThree, style: { top: '70%', left: '10%', width: '150px', rotate: '-8deg' } },
    { src: BrushFour, style: { bottom: '10%', right: '5%', width: '160px', rotate: '12deg' } },
    { src: BrushTwo, style: { top: '60%', left: '50%', width: '140px', rotate: '20deg' } },
    { src: BrushOne, style: { bottom: '30%', right: '30%', width: '160px', rotate: '-15deg' } },
  ]

  return (
    <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
      {brushes.map((brush, i) => (
        <img
          key={i}
          src={brush.src}
          alt={`Brush ${i}`}
          className="absolute"
          style={{ ...brush.style, transform: `rotate(${brush.style.rotate})` }}
        />
      ))}
    </div>
  )
}

function FallingPetals({ count = 30 }) {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-15">
      {Array.from({ length: count }).map((_, i) => {
        const delay = Math.random() * 20
        const duration = 25 + Math.random() * 25
        const startX = Math.random() * 100
        const drift = (Math.random() - 0.5) * 20

        return (
          <motion.img
            key={i}
            src={Cherry}
            className="absolute w-6 h-6"
            style={{ left: `${startX}%` }}
            initial={{ y: '-15vh', opacity: 1, rotate: Math.random() * 360 }}
            animate={{ y: '115vh', x: `${startX + drift}%`, opacity: 0, rotate: Math.random() * 720 }}
            transition={{ repeat: Infinity, duration, delay, ease: 'linear' }}
          />
        )
      })}
    </div>
  )
}

export default function HomePage() {
  const [selected, setSelected] = useState('Tokyo')
  const [menuOpen, setMenuOpen] = useState(false)

  const navLinks = [
    { id: 'hero', label: 'Inicio' },
    { id: 'map', label: 'Mapa' },
    { id: 'highlights', label: 'Highlights' },
    { id: 'music', label: 'Música' },
    { id: 'staff', label: 'Staff' },
    { id: 'footer', label: 'Contacto' },
  ]

  const toggleMenu = () => setMenuOpen(open => !open)
  const closeMenu = () => setMenuOpen(false)

  return (
    <div className="relative font-sans">
      <BrushBackgrounds />

      {/* Navbar */}
      <nav className="fixed top-0 left-0 w-full z-50  bg-opacity-60 backdrop-blur-md">
        <div className="container mx-auto flex items-center justify-between py-4 px-6">
          <Link to="/" onClick={closeMenu}>
            <img src={SmallLogo} alt="Simanof Logo" className="w-12 h-auto" />
          </Link>

          {/* desktop links */}
          <ul className="hidden md:flex space-x-8">
            {navLinks.map(link => (
              <li key={link.id}>
                <ScrollLink
                  to={link.id}
                  smooth
                  duration={600}
                  offset={-80}
                  className="cursor-pointer text-black hover:text-red-500 transition"
                >
                  {link.label}
                </ScrollLink>
              </li>
            ))}
          </ul>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/itinerary"
              className="px-4 py-2 border border-black rounded font-medium hover:bg-red-500 hover:text-white transition"
            >
              Itinerary
            </Link>
            <Link
              to="/Competition"
              className="px-4 py-2 border border-red-600 bg-red-600 text-white rounded font-medium hover:bg-red-700 transition"
            >
              Competition
            </Link>
            <Link
              to="/SignInTerminal"
              className="px-4 py-2 border border-black rounded font-medium hover:bg-red-500 hover:text-white transition"
            >
              Log In
            </Link>
          </div>

          {/* mobile hamburger */}
          <button
            className="md:hidden p-2 text-2xl text-black focus:outline-none"
            onClick={toggleMenu}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* mobile menu */}
        {menuOpen && (
          <div className="md:hidden  bg-opacity-90">
            <ul className="flex flex-col space-y-4 p-6">
              {navLinks.map(link => (
                <li key={link.id}>
                  <ScrollLink
                    to={link.id}
                    smooth
                    duration={600}
                    offset={-80}
                    className="block text-lg text-black hover:text-red-500 transition"
                    onClick={closeMenu}
                  >
                    {link.label}
                  </ScrollLink>
                </li>
              ))}
              <li>
                <Link
                  to="/itinerary"
                  className="block text-lg px-4 py-2 border border-black rounded text-center hover:bg-red-500 hover:text-white transition"
                  onClick={closeMenu}
                >
                  Itinerary
                </Link>
              </li>
              <li>
                <Link
                  to="/Competition"
                  className="block text-lg px-4 py-2 border border-red-600 bg-red-600 text-white rounded text-center hover:bg-red-700 transition"
                  onClick={closeMenu}
                >
                  Competition
                </Link>
              </li>
              <li>
                <Link
                  to="/SignInTerminal"
                  className="block text-lg px-4 py-2 border border-black rounded text-center hover:bg-red-500 hover:text-white transition"
                  onClick={closeMenu}
                >
                  Log In
                </Link>
              </li>
            </ul>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section id="hero" className="relative h-screen pt-16 overflow-hidden">
        <img src={Sky} alt="Sky" className="absolute inset-0 w-full h-full object-cover z-0" />
        <img src={Mountain} alt="Fuji" className="absolute bottom-0 w-full object-cover z-10" />
        <FallingPetals count={40} />
        <img
          src={Logo}
          alt="Simanof Japan Tour Logo"
          className="absolute left-1/2 bottom-[42%] -translate-x-1/2 w-2/5 max-w-lg z-20"
        />
        <div className="absolute bottom-12 w-full flex justify-center z-30">
          <Link to="/Onboard">
            <motion.button
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
              className="px-10 py-4 md:px-12 md:py-5 text-lg md:text-xl bg-red-500 text-white font-semibold rounded-full shadow-xl hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-red-300"
            >
              Register
            </motion.button>
          </Link>
        </div>
      </section>

      {/* Map & City Info */}
      <section id="map" className="py-24 bg-white bg-opacity-90 relative z-10">
        <div className="container mx-auto flex flex-col-reverse md:flex-row items-center gap-12">
          <div className="md:flex-1 space-y-6">
            <h2 className="text-3xl font-serif">{cityData[selected].title}</h2>
            <p className="text-gray-700 leading-relaxed">{cityData[selected].text}</p>
            <img
              src={cityData[selected].img}
              alt={cityData[selected].title}
              className="w-full h-auto rounded-lg shadow-lg mt-4"
            />
          </div>
          <div className="md:flex-1 relative">
            <img src={Mapaa} alt="Map of Japan" className="w-full h-auto rounded-lg shadow-lg" />
            {Object.keys(cityData).map(city => {
              const pos = {
                Tokyo: { top: '30%', left: '65%' },
                Kyoto: { top: '50%', left: '50%' },
                Osaka: { top: '55%', left: '60%' },
              }[city]
              return (
                <button
                  key={city}
                  onClick={() => setSelected(city)}
                  className={`absolute w-5 h-5 rounded-full shadow-lg transition ${
                    selected === city ? 'bg-red-700 scale-110' : 'bg-red-500'
                  }`}
                  style={{ top: pos.top, left: pos.left }}
                  title={city}
                />
              )
            })}
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section id="highlights" className="py-24 bg-white bg-opacity-90 relative z-10">
        <h2 className="text-3xl text-center mb-12 font-serif text-black">Tour Highlights</h2>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
          {highlights.map((item, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.03 }}
              className="bg-white border-2 border-black rounded-xl overflow-hidden transition"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-48 object-cover border-b-2 border-black"
              />
              <div className="p-5">
                <h3 className="text-lg font-semibold text-red-600 mb-2">{item.title}</h3>
                <p className="text-sm text-black leading-snug">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Music */}
      <section id="music" className="py-24 bg-white bg-opacity-90 relative z-10">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-serif mb-12 text-center text-black">The Music Journey</h2>
          <div className="flex flex-col-reverse md:flex-row items-center gap-12">
            <div className="md:w-1/2 text-gray-800 text-md leading-relaxed space-y-6">
              <p>
                At the heart of the Simanof Japan Tour is the power of music. Our orchestra will
                perform in two of Japan’s most dynamic cities:{' '}
                <span className="text-red-600 font-semibold">Tokyo</span> and{' '}
                <span className="text-red-600 font-semibold">Osaka</span>, sharing our sound with
                international audiences in iconic venues.
              </p>
              <p>
                In addition to the concerts, students will participate in hands-on masterclasses
                led by world-renowned Japanese musicians.
              </p>
              <p>
                This is not just a tour — it’s a celebration of unity through music, where passion
                meets tradition, and young performers create lifelong memories on stage.
              </p>
            </div>
            <div className="md:w-1/2">
              <img
                src={Japanmusic}
                alt="Japan Music Logo"
                className="w-full max-w-md mx-auto rounded-xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Staff */}
      <section id="staff" className="py-24 bg-white bg-opacity-90 relative z-10">
        <h2 className="text-3xl text-center mb-12 font-serif text-black tracking-wide">
          Meet Our Team
        </h2>
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 px-4">
          {staff.map(member => (
            <div
              key={member.name}
              className="bg-white border border-gray-200 rounded-xl px-6 pt-6 pb-8 text-center relative"
            >
              <div className="absolute -top-3 -right-3 w-6 h-6 bg-red-600 rounded-full"></div>
              <img
                src={member.img}
                alt={member.name}
                className="mx-auto w-24 h-24 object-cover rounded-full border-4 border-white mb-4 shadow-md"
              />
              <h3 className="text-lg font-semibold text-black">{member.name}</h3>
              <p className="text-sm text-red-600 font-medium">{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer id="footer" className="py-12 bg-white bg-opacity-90 relative z-10">
        <div className="container mx-auto text-center text-gray-600">
          © 2025 Simanof Japan Tour • All rights reserved
        </div>
      </footer>
    </div>
  )
}
